import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const useOpenEditCategory = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const openEditCategory = useMemo(() => {
    const isOpen = searchParams.get('open-edit-category') === 'true';
    const categoryId = searchParams.get('category-id');
    const categoryType = searchParams.get('category-type');
    return isOpen && !!categoryId && !!categoryType;
  }, [searchParams]);

  const categoryId = useMemo(() => {
    return searchParams.get('category-id') || null;
  }, [searchParams]);

  const categoryType = useMemo(() => {
    return searchParams.get('category-type') as CategoryType | null;
  }, [searchParams]);

  const setOpenEditCategory = useCallback((value: boolean | null, id: string | null, type: CategoryType | null) => {
    const newParams = new URLSearchParams(searchParams);
    if (value && id && type) {
      newParams.set('open-edit-category', 'true');
      newParams.set('category-id', id);
      newParams.set('category-type', type);
    } else {
      newParams.delete('open-edit-category');
      newParams.delete('category-id');
      newParams.delete('category-type');
    }
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  return [openEditCategory, setOpenEditCategory, categoryId, categoryType] as const;
};

export default useOpenEditCategory;
